import { IAddress } from "models/entities/Customer";
import { IVisit } from "models/Visits/IVisit";

type AddressLike = Partial<IAddress> | Partial<IVisit>;


export function formatAddress(address: AddressLike, separator = ', '): string {
  let number = getStringProperty(address, 'number');
  let street = getStringProperty(address, 'street') || getStringProperty(address, 'dsAddress') || '';
  const city = getStringProperty(address, 'city') || getStringProperty(address, 'nmCity') || '';
  const state = getStringProperty(address, 'state') || getStringProperty(address, 'nmState') || '';

  if (!number && street) {
    const extracted = extractNumberFromStreet(street);
    if (extracted) {
      street = extracted.street;
      number = extracted.number;
    }
  }

  const addressParts: string[] = [];
  if (street && number) {
    addressParts.push(`${number}${separator}${street}`);
  } else if (street) {
    addressParts.push(street);
  } else if (number) {
    addressParts.push(number);
  }
  if (city) addressParts.push(city);
  if (state) addressParts.push(state);

  return addressParts.join(separator);
}

function getStringProperty(obj: any, prop: string): string {
  const value = obj[prop];
  return value !== undefined && value !== null ? String(value) : '';
}

function extractNumberFromStreet(street: string): { street: string; number: string } | null {
  let match = street.match(/^(.*?)[,\s]+(\d+)$/);
  if (match) return { street: match[1].trim(), number: match[2] };
  match = street.match(/^(\d+)[,\s]+(.*)$/);
  if (match) return { street: match[2].trim(), number: match[1] };
  return null;
}
